import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { isAllowedReturnUrl } from '../utils/ssoAuth';

const API = process.env.REACT_APP_SERVER_URL;

export default function SsoHandoffPage() {
  const [message, setMessage] = useState('Проверяем авторизацию…');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const returnUrl = params.get('return');

    if (!returnUrl || !isAllowedReturnUrl(returnUrl)) {
      window.location.replace('/');
      return;
    }

    const token = localStorage.getItem('token');
    if (!token) {
      window.location.replace(returnUrl);
      return;
    }

    fetch(`${API}/api/auth/sso-code`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (ok && data?.code) {
          const sep = returnUrl.includes('?') ? '&' : '?';
          window.location.replace(`${returnUrl}${sep}code=${encodeURIComponent(data.code)}`);
          return;
        }
        window.location.replace(returnUrl);
      })
      .catch(() => {
        setMessage('Не удалось передать сессию. Перенаправляем…');
        setTimeout(() => window.location.replace(returnUrl), 800);
      });
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '50vh', gap: 2 }}>
      <CircularProgress />
      <Typography color="text.secondary">{message}</Typography>
    </Box>
  );
}
